"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var head = require("headjs/dist/1.0.0/head.load.min");
var ScriptsInjector = /** @class */ (function () {
    function ScriptsInjector() {
    }
    ScriptsInjector.prototype.inject = function (modLoader, modConfig) {
        var modulePaths = modConfig.map(function (module) {
            return module.ModuleName;
        });
        head.load(modulePaths, function () {
            modLoader.trigger("afterload", true);
        });
    };
    return ScriptsInjector;
}());
exports.ScriptsInjector = ScriptsInjector;
//# sourceMappingURL=ScriptsInjector.js.map